import { Target } from '@griply/assets';
import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import {
  EmptyState,
  EmptyStateVariants,
} from 'shared/components/ui/empty-state';
import { goalsHelpLink } from 'shared/constants';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { ID } from 'shared/types/id';

export type EmptyBannerProps = {
  lifeAreaId?: ID;
};

export const EmptyBanner: React.FC<EmptyBannerProps> = ({ lifeAreaId }) => {
  const { t } = useTranslation();

  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();

  const onAdd = () =>
    createGoalAllowed
      ? openCreateGoalDialog({ lifeAreaId })
      : openPremiumDialog();

  return (
    <EmptyState
      icon={Target}
      variant={EmptyStateVariants.Page}
      title={t('pages.goals.empty.title')}
      description={
        <Trans
          i18nKey="pages.goals.empty.description"
          components={{
            help: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans clones this with the translated label as children
              <a
                key="help"
                href={goalsHelpLink}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
    >
      <Button
        onClick={onAdd}
        size={Sizes.Medium}
        variant={Variants.Contained}
        color={Colors.Primary}
      >
        {t('pages.goals.empty.button.add.label')}
      </Button>
    </EmptyState>
  );
};
